import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useHistory } from "react-router-dom";
import * as api from "../../api/index.js";
import { Box, Grid, Button, Divider } from "@material-ui/core";

import DishCard from "./Card";

const useStyles = makeStyles((theme) => ({
  root: {
    margin: "5px",
    // width: "100%",
    flexGrow: 1,
  },

  Grid: {
    padding: theme.spacing(2),
    maxWidth: 500,
    margin: "5px",
    justifyContent: "left",
    textAlign: "left",
  },

  paper: {
    padding: theme.spacing(2),
    margin: "auto",
    maxWidth: 600,
    borderRadius: "15px",
  },

  image: {
    width: "200px",
    [theme.breakpoints.down("xs")]: {
      textAlign: "center",
      justifyContent: "center",
      width: "250px",
    },
  },

  accordionMain: {
    backgroundColor: "#fffaf7",
    maxWidth: "100%",
    alignItems: "flex-start",
    // marginBottom: "50px",
    justifyContent: "center",
    boxShadow: "none",
    padding: "0",
  },
  accordion: {
    padding: "0",
  },

  accordionHeader: {
    backgroundColor: "#fffaf7",
    borderColor: "#fff",
    maxWidth: "100%",
    alignItems: "flex-start",
    marginBottom: "0px",
    justifyContent: "center",
    boxShadow: "none",
    padding: "0",
  },
  heading: {
    fontFamily: "Gilroy-ExtraBold, serif",
    fontSize: "25px",
    textAlign: "left",
  },
  accordianContent: {
    paddingTop: "20px",
  },

  expandBtn: {
    borderRadius: "20px",
    fontFamily: "Gilroy-Light, serif",
    textTransform: "capitalize",
    justifyContent: "center",
    justifyItems: "flex-end",
    backgroundColor: "#F95919",
    padding: "0 25px",
    color: "#fff",
    height: "40px",
    fontSize: "16px",
    boxShadow: "0 3px 6px rgb(187 131 83 / 25%)",
    marginLeft: "20px",
    marginBottom: "50px",
    "&:hover": {
      backgroundColor: "#e45826",
      boxShadow: "none",
    },
  },
}));

export default function DishDetail({ id }) {
  const classes = useStyles();
  let history = useHistory();

  const [dishes, setDishes] = useState([]);
  const [items, setItems] = useState([]); // eslint-disable-line
  // const [expanded,setExpanded] = useState(expand)
  // eslint-disable-next-line
  const [expand, setExpand] = useState(false);
  // eslint-disable-next-line
  const [accordionIdx, setAccordionIdx] = useState(-1);

  const [indexes, setIndexes] = useState([]);

  const expandAccordion = () => {
    if (!expand) {
      const preparedIndices = [];
      for (let i = 0; i < dishes.length; i++) {
        //setIndexes(pre=>i);
        preparedIndices.push(i);
      }

      //  console.log("index", index);
      setIndexes(preparedIndices);
    } else {
      setIndexes([]);
    }
    setExpand(!expand);
  };

  const handleAccordionIndex = (idx) => {
    let findIdx = indexes.find((id) => id === idx);

    if (findIdx >= 0) {
      for (let i = 0; i < indexes.length; i++) {
        setIndexes((prev) => prev.filter((e) => e !== idx));
      }
    } else {
      setIndexes((prev) => [...prev, idx]);
    }
  };

  const getDishes = async () => {
    try {
      const data = await api.resDish(id);

      setDishes(data.data);
      console.log("dishes******", data.data);
      setItems(data.data.items);
      // setTags(data.data.items.tags);
      // console.log("Tags******",data.data.items );
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    getDishes();
  }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className={classes.root}>
      <Grid
        container
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        //justify="flex-start"
        alignItems="flex-start"
      >
        <Grid
          container
          xs={12}
          sm={12}
          md={12}
          lg={12}
          justify="flex-end"
          alignItems="right"
        >
          {" "}
          <Box>
            {" "}
            <Button
              className={classes.expandBtn}
              onClick={() => history.goBack()}
            >
              Go Back
            </Button>
          </Box>
          <Box>
            {" "}
            <Button className={classes.expandBtn} onClick={expandAccordion}>
              {expand ? "Shrink All" : "Expand All"}
            </Button>
          </Box>
          <Grid
            container
            item
            xs={12}
            sm={12}
            md={12}
            alignItems="center"
            justify="center"
          >
            {/* {id && <DishDetail id={id} expand={expand} expandAccordian={expandAccordian} handleAccordian ={handleAccordian} />} */}
          </Grid>
        </Grid>
      </Grid>

      {dishes.map((dish, idx) => {
        return (
          <Accordion
            className={classes.accordionMain}
            alignItems="flex-start"
            expanded={indexes.includes(idx)}
            // expanded={}
          >
            <AccordionSummary
              expandIcon={
                <Box color="#f95919">
                  <ExpandMoreIcon />
                </Box>
              }
              aria-controls="panel1a-content"
              id="panel1a-header"
              className={classes.accordionHeader}
              onClick={() => handleAccordionIndex(idx)}
              // onclick={()=> checkExpand(idx)}
            >
              <Typography>
                <Box className={classes.heading}>{dish.name}</Box>
              </Typography>
            </AccordionSummary>
            <Divider />
            <AccordionDetails className={classes.accordion}>
              <Grid
                container
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                className={classes.accordianContent}
              >
                {dish.items.map((item, idx) => (
                  <Grid
                    style={{ padding: "0 7px" }}
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={6}
                  >
                    <DishCard
                      item={item}
                      idx={idx}
                      getDishe={getDishes}
                      res={true}
                    />
                  </Grid>
                ))}
              </Grid>
            </AccordionDetails>
          </Accordion>
        );
      })}
    </div>
  );
}
